export default __webpack_public_path__ + "static/media/Wolf's Straps of Woven Clouds.8a31b393.jpg";